/** Attention chime built with Web Audio, deliberately loud enough to cut through a room. Keep in sync with windows_pos. */
import { isMuted } from './notifyMute';

let ctx = null;

export function playNotificationBeep() {
  // Central mute, so every caller goes quiet with one switch and a later chime cannot forget to honour it.
  if (isMuted()) return;
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === 'suspended') ctx.resume();
    const now = ctx.currentTime;
    const tone = (freq, at, dur = 0.28, peak = 0.6) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'triangle'; // richer than sine — carries further
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, now + at);
      gain.gain.exponentialRampToValueAtTime(peak, now + at + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + at + dur);
      osc.connect(gain).connect(ctx.destination);
      osc.start(now + at);
      osc.stop(now + at + dur + 0.05);
    };
    // Rising chime ×2 with a beat between — ~1.6s total.
    [0, 0.85].forEach((base) => {
      tone(880, base);
      tone(1175, base + 0.22);
      tone(1568, base + 0.44, 0.34);
    });
  } catch { /* no audio — silent fallback */ }
}
